// extracted by mini-css-extract-plugin
module.exports = {"autoCompletion":"LabelsDropdown_autoCompletion__3qwSO"};